var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 142,
    viewBox: "0 0 262 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.4355 103.961V139.825C54.4855 141.853 47.0473 142.475 39.7457 141.639C32.444 140.803 25.492 138.533 19.4733 135.019C13.4546 131.506 8.54486 126.851 5.15641 121.447C1.76796 116.043 -0.00033545 110.046 4.77314e-08 103.961C4.77314e-08 96.9591 5.67615 91.283 12.678 91.283H18.0416C25.0435 91.283 30.7196 96.9591 30.7196 103.961C30.7196 107.323 32.3377 110.548 35.2179 112.926C38.098 115.303 42.0044 116.639 46.0776 116.639C50.1508 116.639 54.0571 115.303 56.9373 112.926C59.8175 110.548 61.4355 107.323 61.4355 103.961Z",
    fill: "#355FE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M156.053 40.5647C165.759 40.5647 171.449 51.4886 165.886 59.4423L153.594 77.0171L150.23 81.8357L143.61 91.2829L134.746 103.961L126.855 115.252C122.079 122.085 111.964 122.087 107.185 115.256L99.2847 103.961L108.144 91.2829L117.023 78.6019L134.564 53.5217L140.042 45.688C142.287 42.4773 145.958 40.5647 149.876 40.5647H156.053Z",
    fill: "url(#paint0_linear_1_4547)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.023 78.6019L108.144 91.2829L99.2809 103.961L92.1552 93.7658L90.4211 91.2829L86.5964 85.8298C86.2734 85.3363 85.9355 84.852 85.5679 84.3707L85.475 84.2328L61.4355 49.8464C61.4355 44.7203 65.5911 40.5647 70.7172 40.5647H90.4211L92.1552 43.0506L117.023 78.6019Z",
    fill: "#355FE5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2349 0H73.3778C64.42 0 57.1582 7.26177 57.1582 16.2196C57.1582 25.1775 64.42 32.4392 73.3778 32.4392H80.2349C89.1928 32.4392 96.4546 25.1775 96.4546 16.2196C96.4546 7.26177 89.1928 0 80.2349 0Z",
    fill: "url(#paint1_linear_1_4547)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M200.564 55.754L200.564 126.664C200.564 135.12 207.419 141.974 215.875 141.974C224.33 141.974 231.185 135.12 231.185 126.664L231.185 55.754C231.185 47.2984 224.33 40.4437 215.875 40.4437C207.419 40.4437 200.564 47.2984 200.564 55.754Z",
    fill: "url(#paint2_linear_1_4547)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M162.477 89.668C169.203 80.0526 184.31 84.8119 184.31 96.5464V141.998H153.594V102.376L161.347 91.2829L162.477 89.668Z",
    fill: "url(#paint3_linear_1_4547)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1552 93.7661V103.961C92.1648 110.294 90.2498 116.528 86.5853 122.092L85.4713 123.665C79.952 131.183 71.4539 136.894 61.417 139.831V49.8467L85.4565 84.2331L85.5493 84.371L86.5779 85.8301L90.4025 91.2832L92.1552 93.7661Z",
    fill: "url(#paint4_linear_1_4547)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M249.32 40.5647H213.244C206.241 40.5647 200.564 46.2415 200.564 53.2443C200.564 60.247 206.241 65.9238 213.244 65.9238H249.32C256.323 65.9238 262 60.247 262 53.2443C262 46.2415 256.323 40.5647 249.32 40.5647Z",
    fill: "#355FE5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_4547",
    x1: 139.187,
    y1: 40.5647,
    x2: 139.187,
    y2: 129.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#112E88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0537D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_4547",
    x1: 76.8064,
    y1: 0,
    x2: 76.8064,
    y2: 32.4392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#112E88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0537D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_4547",
    x1: 200.564,
    y1: 91.2091,
    x2: 231.185,
    y2: 91.2091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#112E88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0537D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_4547",
    x1: 168.952,
    y1: 58.4568,
    x2: 168.952,
    y2: 141.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#112E88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0537D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_4547",
    x1: 76.7861,
    y1: 49.8467,
    x2: 76.7861,
    y2: 139.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#112E88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0537D8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2eda7c14c0bcadbb516d8e2dc96f2ae6.svg";
export { ForwardRef as ReactComponent };